var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "basket-list-item py-3" }, [
    _c(
      "div",
      { staticClass: "basket-item component-loading with-icon d-flex" },
      [
        _c("div", { staticClass: "meta-container-wrapper" }, [
          _c("div", { staticClass: "meta-container-wrapper-inner mb-2 ml-1" }, [
            _c("div", { staticClass: "position-relative w-75" }, [
              _c("div", { staticClass: "small" }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.wishListInactiveItemId")
                    ) + ":"
                  ),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.wishListInactiveItem))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "small" }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.wishListAvailability")
                    ) + ":"
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "badge badge-danger" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Ceres::Template.wishListInactiveItemAvailability"
                      )
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "basket-item-container-right w-25" }, [
          _c(
            "div",
            {
              staticClass: "btn btn-sm text-danger p-0 float-right",
              attrs: { "data-testing": "remove-wlist-item" },
              on: {
                click: function ($event) {
                  return _vm.removeInactiveItem()
                },
              },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$translate("Ceres::Template.wishListDelete")) +
                  "\n          "
              ),
              _c("i", {
                directives: [
                  {
                    name: "waiting-animation-infinite",
                    rawName: "v-waiting-animation-infinite",
                  },
                ],
                staticClass: "fa fa-trash-o default-float",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }